module.exports = __webpack_public_path__ + "Sailec-Regular.02bd43b27c979214d466.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Regular/Sailec-Regular.ttf
// module id = ../../../../../src/assets/fonts/Sailec-Regular/Sailec-Regular.ttf
// module chunks = styles